import React, { useContext, useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import LeftSidePopupLayout from "../../../../component/popup/modal-layout";
import XCloseIcon from "../../../../component/icons/x-close";
// import Style from "./style.module.css";
import { GlobalContext } from "../../../../context/Context";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import Tooltip from "../../../../component/ui/tooltip";
import { Loader2, Trash2 } from "lucide-react";
import Select from "react-select";
import {
  FeildError,
  FeildWraper,
  FormArea,
  FormLabel,
  FormLineBreak,
} from "../../../../component/form/form-layout";

const stripHtml = (html) => (html || "").replace(/<[^>]*>?/gm, "");

const AddUpdateTeam = ({
  onSubmit = () => {},
  onClose = () => {},
  onError = () => {},
  teamData = {},
  Style,
}) => {
  const { state } = useContext(GlobalContext);
  const apiCall = useApiCall();
  const [status,setStatus] = useState(1);

  useEffect(() => {
    console.log("teamData", teamData);

    if (teamData?.team_id) {
      formik.setFieldValue("team_name", teamData?.team_name);
      formik.setFieldValue("unit_id", teamData?.unit_id);
      formik.setFieldValue("ttype", teamData?.ttype);
      // formik.setFieldValue(status, teamData?.status);
      setStatus(teamData?.status)
    }
  }, []);

  const validationSchema = yup.object({
    team_name: yup.string().required("This Field is Required"),
    unit_id: yup.number().required("This Field is Required"),
    ttype: yup.string().required("This Field is Required"),
    // status: yup.string().required("This Field is Required"),
  });

  // Formik
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      team_name: "",
      unit_id: 0,
      ttype: "",
      // status: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      const data = {
        team_name: values.team_name,
        unit_id: values.unit_id,
        ttype: values.ttype,
        status: Number(status),
      };

      console.log("values", data);

      try {
        const url = teamData?.team_id
          ? `teams/update-team/${teamData?.team_id}`
          : `teams/add-team`;
        const apiRes = await apiCall({
          method: "post",
          url,
          data,
        });
        if (onSubmit) onSubmit(apiRes?.message || "Add Team successfully");
        formik.resetForm();
        onClose();
      } catch (error) {
        onError(
          error?.response?.data?.respMsg ||
            error?.response?.data?.responseMessage ||
            error?.response?.data?.message ||
            "Something went wrong"
        );
      }
    },
  });

  const teamType = [
    {
      value: "Fresh",
      label: "Fresh",
    },
    {
      value: "Upsell",
      label: "Upsell",
    },
  ];

  const teamTypeOptions = teamType?.map((tm) => ({
    value: tm?.value,
    label: tm?.label,
  }));

  return (
    <div style={{ height: "100%", overflow: "auto" }}>
      <form onSubmit={formik.handleSubmit} className={Style.modal_main}>
        {/* Body */}
        <div className={Style.modal_body}>
          <FormArea>
            {/* Team Name */}

            <FeildWraper width="100%">
              <FormLabel required>Team Name</FormLabel>

              <input
                type="text"
                name="team_name"
                value={formik.values.team_name}
                onChange={formik.handleChange}
                placeholder="Team Name"
              />
              {formik.touched.team_name && formik.errors.team_name && (
                <FeildError>{formik.errors.team_name}</FeildError>
              )}
            </FeildWraper>

            {/* ttype */}
            <FeildWraper width="100%">
              <FormLabel required>Team type</FormLabel>
              <Select
                name="ttype"
                className="text-sm"
                classNamePrefix="react-select"
                options={teamTypeOptions}
                components={{
                  IndicatorSeparator: () => null,
                  LoadingIndicator: () => null,
                }}
                value={teamTypeOptions?.find(
                  (option) => option.value == formik?.values?.ttype
                )}
                onChange={(selectedOption) => {
                  formik.setFieldValue("ttype", selectedOption?.value || "");
                }}
                filterOption={(option, inputValue) =>
                  option?.label
                    .toLowerCase()
                    .includes(inputValue?.toLowerCase())
                }
                placeholder="Search or select Team Type..."
                isClearable
                menuPlacement="auto"
                styles={{
                  control: (base, state) => ({
                    ...base,
                    minHeight: "35px",
                    height: "auto",
                    borderRadius: "5px",
                    border: "1px solid #DFDFDF",
                    backgroundColor: state.isDisabled ? "#f0f0f0" : "#FFF",
                    boxShadow: state.isFocused ? "none" : "none",
                    "&:hover": { borderColor: "#DFDFDF" },
                    fontSize: "13px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#1E1E1E",
                    padding: "0 14px",
                    cursor: state.isDisabled ? "not-allowed" : "normal", // cursor change
                  }),
                  valueContainer: (base) => ({
                    ...base,
                    height: "auto",
                    padding: "0 0px 0",
                  }),
                  input: (base) => ({
                    ...base,
                    margin: 0,
                    padding: 0,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#1E1E1E",
                    height: "auto",
                  }),
                  singleValue: (base) => ({
                    ...base,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#1E1E1E",
                  }),
                  placeholder: (base) => ({
                    ...base,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#717680",
                  }),
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 99999,
                  }),
                  menu: (base) => ({
                    ...base,
                    marginTop: "2px",
                    borderRadius: "5px",
                    border: "1px solid #DFDFDF",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  }),
                  option: (base, state) => ({
                    ...base,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: state.isSelected ? "#FFF" : "#1E1E1E",
                    backgroundColor: state.isSelected
                      ? "#3b82f6"
                      : state.isFocused
                      ? "#F3F4F6"
                      : "#FFF",
                    padding: "8px 14px",
                    cursor: "pointer",
                  }),
                  indicatorContainer: (base) => ({ ...base, padding: 0 }),
                  dropdownIndicator: (base) => ({ ...base, padding: 0 }),
                }}
              />
              {formik.touched.ttype && formik.errors.ttype && (
                <FeildError>{formik.errors.ttype}</FeildError>
              )}
            </FeildWraper>

            {/* Status */}
            {/* <FeildWraper width="100%">
              <FormLabel required>Status</FormLabel>
              <select
                name="status"
                value={formik.values.status}
                onChange={formik.handleChange}
              >
                <option value="" disabled selected>
                  -- Select Product Status --
                </option>
                <option value="1">Active</option>
                <option value="0">InActive</option>
              </select>
              <div className="flex !justify-start">
                <input type="radio"  checked name="status"/>
                Active
              </div>
              


              {formik.touched.status && formik.errors.status && (
                <FeildError>{formik.errors.status}</FeildError>
              )}
            </FeildWraper> */}

            <div className="w-full px-3 flex flex-col gap-2">
                <div>
                  <p className="!text-sm !font-medium !leading-5  !text-[#1E2E54]">
                    Status
                  </p>
                </div>
                <div className="flex gap-5 items-center text-sm">
                  <label className="flex gap-1 font-sm font-medium leading-5  text-[#1E2E54]">
                    <input
                      type="radio"
                      name="status"
                      value="upload"
                      checked={status == 1}
                      onChange={() => setStatus(1)}
                    />
                    Active
                  </label>

                  <label className="flex gap-1 font-sm font-medium leading-5  text-[#1E2E54]">
                    <input
                      type="radio"
                      name="status"
                      value="url"
                      checked={status == 0}
                      onChange={() => setStatus(0)}
                    />
                    In Active
                  </label>
                </div>
              </div>
          </FormArea>
        </div>

        {/* Footer */}
        <div className={Style.modal_foot}>
          <button
            type="button"
            className={`${Style.dcmb__cancel} opacity-0 pointer-events-none cursor-default`}
            onClick={onClose}
          >
            Discard
          </button>
          <button type="submit" className={Style.dcmb__submit}>
            {teamData?.team_id ? "Update" : "Apply"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddUpdateTeam;
